// src/domains/sales/deals/pages/create-page/sales-deals-create-page.jsx

import SalesDealsApi from 'api/admins/sales-deals-api'
import { RedirectButton, TitlePage } from 'components/atoms'
import { ALERT_TYPES } from 'constants/alert-constants'
import { SalesDealsCreateForm } from 'domains/sales/deals/forms'
import PropTypes from 'prop-types'
import { Card } from 'reactstrap'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const buildFullName = (firstName, lastName) => {
  const first = (firstName || '').trim()
  const last  = (lastName || '').trim()
  return [first, last].filter(Boolean).join(' ')
}

const normalizeShipmentCost = (value) => {
  const normalized = Number(value)
  return Number.isFinite(normalized) && normalized >= 0 ? normalized : 0
}

const SalesDealsCreatePage = ({ pageUtils }) => {
  const handleSubmitForm = async (values, formikBag) => {
    const {
      product_ids,
      product_search,
      hide_existing_user_detail,
      first_name,
      last_name,
      dp_transfer_proofs = [],
      payment_transfer_receipts = [],
      ...payload
    } = values || {}

    // ---------- name ----------
    const fullName = buildFullName(first_name, last_name)
    if (fullName) payload.name = fullName

    // ---------- assist_by_list → assist_by ----------
    const cleanedAssistList = (payload.assist_by_list || [])
      .map(x => (x || '').trim())
      .filter(Boolean)

    payload.assist_by_list = Array.from(new Set(cleanedAssistList))
    payload.assist_by = payload.assist_by_list.join(', ')

    // ---------- items ----------
    payload.items = (payload.items || []).map(it => ({
      product_id: it.product_id,
      selling_price: it.selling_price,
      authenticator: it.authenticator,
      authenticity_check_note: it.authenticity_check_note,
      include_authenticity_check: it.include_authenticity_check,
      note: it.note,
    }))

    payload.shipment_cost = normalizeShipmentCost(payload.shipment_cost)

    try {
      const response = await SalesDealsApi.create(payload)
      const deal = response?.data?.data || response?.data
      const dealId = deal?.id

      // ---------- upload payment receipts after deal created ----------
      // ---------- upload DP proofs first ----------
      // IMPORTANT:
      // Bukti bayar pertama harus lebih dulu di-upload agar deal langsung
      // masuk ke waiting_for_confirmation untuk direview Finance.
      if (dealId && dp_transfer_proofs.length > 0) {
        try {
          await SalesDealsApi.uploadDownPaymentProof(dealId, dp_transfer_proofs)
        } catch (uploadErr) {
          console.error(uploadErr)

          pageUtils.setAlertMsg(
            <>
              Deals berhasil dibuat, tapi upload bukti transfer DP gagal.{' '}
              <RedirectButton
                text="Lihat Detail Deals"
                path={`/app/sales/deals/${dealId}`}
              />
            </>,
            ALERT_TYPES.WARNING
          )

          formikBag.resetForm()
          return
        }
      }

      // ---------- upload optional payment receipts after DP proof ----------
      if (dealId && payment_transfer_receipts.length > 0) {
        try {
          const formData = new FormData()
          payment_transfer_receipts.forEach((file) => {
            formData.append('all_receipt_urls[]', file)
          })

          await SalesDealsApi.uploadTransferReceipt({
            dealId,
            formData,
          })
        } catch (uploadErr) {
          console.error(uploadErr)

          pageUtils.setAlertMsg(
            <>
              Deals berhasil dibuat, tapi upload bukti pelunasan gagal.{' '}
              <RedirectButton
                text="Lihat Detail Deals"
                path={`/app/sales/deals/${dealId}`}
              />
            </>,
            ALERT_TYPES.WARNING
          )

          formikBag.resetForm()
          return
        }
      }

      pageUtils.setAlertMsg(
        <>
          Deals berhasil dibuat{' '}
          <RedirectButton
            text="Lihat Detail Deals"
            path={`/app/sales/deals/${dealId}`}
          />
        </>,
        ALERT_TYPES.SUCCESS
      )

      formikBag.resetForm()
    } catch (error) {
      pageUtils.setApiErrorMsg(error.response?.data)
    } finally {
      formikBag.setSubmitting(false)
    }
  }

  const checkUserEmailIsUnique = async (email) => {
    try {
      const res = await SalesDealsApi.isUserEmailUnique({ email })
      if (!res.data.is_unique) {
        pageUtils.setAlertMsg('Email sudah terdaftar', ALERT_TYPES.DANGER)
      }
    } catch (e) {
      pageUtils.setApiErrorMsg(e.response?.data)
    }
  }

  const checkUserPhoneIsUnique = async (phone) => {
    try {
      // const res = await SalesDealsApi.isUserPhoneUnique({ phone })
      // if (!res.data.is_unique) {
      //   pageUtils.setAlertMsg('Phone sudah terdaftar', ALERT_TYPES.DANGER)
      // }
      console.log(phone)
    } catch (e) {
      pageUtils.setApiErrorMsg(e.response?.data)
    }
  }

  return (
    <>
      <TitlePage mainTitle="Buat Deals" />
      <Card body>
        <SalesDealsCreateForm
          onSubmitForm={handleSubmitForm}
          checkUserEmailIsUnique={checkUserEmailIsUnique}
          checkUserPhoneIsUnique={checkUserPhoneIsUnique}
        />
      </Card>
    </>
  )
}

SalesDealsCreatePage.propTypes = propTypes
export default SalesDealsCreatePage
